import React from 'react'
import classNames from 'classnames'

import SuitcaseIcon from '../../../../assets/_V2/svg/SuitcaseIcon'

import CardIconOne from './assets/CardIconOne'
import CardIconTwo from './assets/CardIconTwo'
import CardIconThree from './assets/CardIconThree'
import CardIconFour from './assets/CardIconFour'

import styles from './styles.module.scss'

export default {
  heading: (
    <span className={classNames(styles.heading, styles.colorBluePrimary)}>
      <SuitcaseIcon />
      Процесс
    </span>
  ),
  textarea: (
    <>
      <span className={styles.contentDesktop}>
        Работаем на опыте реальных заведений, помогаем запускать и развивать
        бизнес.
        <br />
        Действуем по плану, двигаемся чётко к цели.
      </span>
      <span className={styles.contentTablet}>
        Работаем на опыте реальных заведений, помогаем запускать и развивать
        бизнес.
        <br />
        Действуем по плану, двигаемся чётко к цели.
      </span>
      <span className={styles.contentMobile}>
        Работаем на опыте реальных заведений, помогаем запускать и развивать бизнес. Действуем по плану, двигаемся чётко к цели.
      </span>
    </>
  ),
  cardList: [
    {
      theme: styles.white,
      id: 0,
      icon: <CardIconOne />,
      heading: 'Брифинг',
      content: (
        <ul className={styles.ul}>
          <li>Согласовываем цель обучения с задачи бизнеса</li>
          <li>Составляем кейс по заведению</li>
          <li>Участники обучения, их роли в компании</li>
        </ul>
      ),
    },
    {
      theme: styles.white,
      id: 1,
      icon: <CardIconTwo />,
      heading: 'Программа',
      content: (
        <ul className={styles.ul}>
          <li>Разрабатываем план обучения на основе кейса</li>
          <li>Проводим технический бриф для обучения</li>
          <li>Назначаем дату первого занятия</li>
        </ul>
      ),
    },
    {
      theme: styles.white,
      id: 2,
      icon: <CardIconThree />,
      heading: 'Обучение',
      content: (
        <ul className={styles.ul}>
          <li>Онлайн формат с домашним заданием</li>
          <li>На занятии назначаем дату следующего</li>
          <li>Занятие проводим только после выполнения ДЗ</li>
        </ul>
      ),
    },
    {
      theme: styles.white,
      id: 3,
      icon: <CardIconFour />,
      heading: 'Оценка',
      content: (
        <ul className={styles.ul}>
          <li>Собираем обратную связь по результатам обучения</li>
          <li>
            Составляем методические рекомендации для сорудников и руководителя
          </li>
        </ul>
      ),
    },
  ],
}
